export default __webpack_public_path__ + "img/fb986e5b79d1402a9fa099ffc6dc68cf.png";